import './CountryCoverageModal.scss';

import { Resource } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import CountryCoverage from '../CountryCoverage/CountryCoverage';
import Modal from '../Modal';

interface CountryCoverageModalProps {
  on: boolean;
  onCloseButton: () => void;
  countries: Resource[];
}
const className = 'c-CountryCoverageModal';

const CountryCoverageModal = ({
  on,
  onCloseButton,
  countries,
}: CountryCoverageModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('label.countryCoverage', 'Coverage')}
      toggle={onCloseButton}
      on={on}
      closeOnBackgroundClick={true}
      closeOnEscapeClick={true}
      fullScreen={true}
      fixed={true}
    >
      <div className={className}>
        <CountryCoverage extended countries={countries} autoFocus />
      </div>
    </Modal>
  );
};

export default CountryCoverageModal;
